import React from 'react';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import InsideSection from './components/InsideSection';
import PreviewSection from './components/PreviewSection';
import FitAndScripts from './components/FitAndScripts';
import PricingSection from './components/PricingSection';
import FaqSection from './components/FaqSection';
import FinalCta from './components/FinalCta';
import './App.css';

function App() {
  return (
    <main>
      <Hero />
      <ProblemSection />
      <InsideSection />
      <PreviewSection />
      <FitAndScripts />
      <PricingSection />
      <FaqSection />
      <FinalCta />
    </main>
  );
}

export default App;